import React from 'react'
import { environment } from '../../config/environment'

const getDisplayName = (WrappedComponent) =>
    WrappedComponent.displayName || WrappedComponent.name || 'Component'

export default function withTestId(WrappedComponent, testId) {
    if (environment.mode !== 'test') {
        return WrappedComponent
    }
    const WithTestId = (props) => (
        <WrappedComponent data-testid={testId} {...props} />
    )
    WithTestId.displayName = `WithTestId(${getDisplayName(WrappedComponent)})`
    WithTestId.TEST_ID = testId
    return WithTestId
}
